export const Logo = ({ dark = false }) => {
  const main = dark ? "text-white" : "text-forest";
  const sub = dark ? "text-white/60" : "text-charcoal-muted";
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="brand-logo">
      <span className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-forest text-white font-heading font-extrabold text-lg">H</span>
      <span className="leading-none">
        <span className={`block font-heading font-extrabold tracking-tight text-xl ${main}`}>HANSERA</span>
        <span className={`block text-[10px] uppercase tracking-[0.18em] ${sub}`}>Gebäudeservice &amp; Objektpflege</span>
      </span>
    </div>
  );
};
